/**
 * Was die Bedienelemente der Bewertungsseite ZUSAGEN -- an EINER Stelle.
 *
 * Warum das hier liegt: der Hinweis am "Neu bewerten"-Knopf stand als fertiger
 * Satz im Template, und sein Test hielt drei Bruchstuecke davon woertlich fest
 * ("Loescht alle Bewertungen", "erst das loest", "freigegebene"). Jede
 * Umformulierung machte den Test rot, ohne dass sich an der Sache etwas
 * geaendert haette -- und das ist am 18.08. zweimal an einem Tag passiert.
 *
 * Die Umkehrung: eine Aussage bekommt einen NAMEN. Der Wortlaut daneben ist
 * frei und darf jederzeit gekuerzt oder umformuliert werden; ein Schluessel
 * verschwindet nur, wenn die Aussage selbst verschwindet. Der Test prueft
 * Schluessel, Bindung und Laenge -- nie die Prosa.
 *
 * Dieselbe Konvention wie shortcuts.js (KUERZEL), merkliste.js (MERK_MAX) und
 * promptMass.js (PROMPT_WARN_ZEICHEN): eine Zahl, eine Quelle.
 */

/**
 * Wie lang ein Hinweis am Bedienelement hoechstens sein darf.
 *
 * Die Zahl stand bis zum 18.08. getippt im Test und nirgends sonst. Sie ist
 * keine Kosmetik: ohne Schranke waechst so ein Hinweis wieder zum Absatz
 * zurueck, weil jeder einzelne Zusatz fuer sich genommen begruendet aussieht.
 * Der Hinweis soll die Sache sagen, nicht die Mechanik dahinter erklaeren.
 */
export const HINWEIS_MAX_ZEICHEN = 160;

/**
 * Die drei Aussagen, die der Hinweis an "Neu bewerten" treffen MUSS.
 *
 * preis        -- es wird geloescht, und zwar auch von Hand Korrigiertes
 * grund        -- erst das Loeschen loest die neue Bewertung aus (der
 *                 RatingWorker waehlt ueber rated_count < total_criterias,
 *                 nicht ueber reviewed)
 * nebenwirkung -- eine Freigabe wird dabei zurueckgenommen; das erwartet
 *                 sonst niemand
 */
export const NEU_BEWERTEN = {
  preis: "Löscht alle Bewertungen",
  grund: "erst das löst eine neue Bewertung aus",
  nebenwirkung: "Eine freigegebene Nachricht wird wieder geöffnet",
};

/**
 * Ein Hinweis aus seinen Aussagen.
 *
 * ACHTUNG: die Reihenfolge ist Absicht. Der Preis steht vorn, weil er die
 * Entscheidung traegt; die Nebenwirkung steht hinten, weil sie die Ausnahme
 * ist. Wer die Formel aendert, aendert die Laenge -- und die wird geprueft.
 */
export function hinweisText({ preis, grund, nebenwirkung }) {
  return `${preis} — ${grund}. ${nebenwirkung}.`;
}
